import React from 'react';
import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import PropTypes from 'prop-types';
import { Input, Col } from 'antd';

/**
 * Componente Molecule para barra de filtros do apontamento
 */
function ApontamentoFilterBar({ filterName, onFilterNameChange, disabled }) {
  return (
    <Col
      xs={24}
      sm={24}
      md={12}
      lg={6}
      xl={6}
    >
      <Label label="Filtrar por nome">
        <Input
          type="text"
          value={filterName}
          onChange={(e) => onFilterNameChange(e.target.value)}
          placeholder="Nome do cooperado"
          allowClear
          disabled={disabled}
        />
      </Label>
    </Col>
  );
}

ApontamentoFilterBar.propTypes = {
  filterName: PropTypes.string,
  onFilterNameChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ApontamentoFilterBar.defaultProps = {
  filterName: undefined,
  disabled: false,
};

export default ApontamentoFilterBar;
